import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#i474134493__a)" }, [
      _createElementVNode("path", {
        fill: "#1D1D1D",
        d: "M14 6.053 13.061 5l-4.82 5.406c-.14.143-.355.143-.482 0L2.939 5 2 6.053l4.82 5.406c.647.726 1.7.726 2.36 0L14 6.053Z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i474134493__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M2 5h12v7H2z"
        })
      ])
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "arrow-down"}) } }